import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';

import * as yup from 'yup';

/** Test mock converter settings response body */
export interface ConverterTestMockFindInterface {
  /** Computed unique "fingerprint" for converter (need for auth) */
  fingerprint?: string;
}

/** Test mock converter settings response body */
export const ConverterTestMockFindDto = SerdeDtoClass.create<ConverterTestMockFindInterface>(PacsDtoKeysEnum.CONVERTER_TEST_MOCK_FIND_DTO, {
  fingerprint: {
    optional: true,
    label: 'Цифровой отпечаток',
    serializer: yup.string(),
  },
});
